import enumeration from "./enumeration";

const BookingItemType = {
  PLACE: "PLACE",
  PRODUCT: "PRODUCT",
};

export default enumeration(BookingItemType);
